(() => {
  if (window.MayLondonStyleCatalog) return;
  const requests = new Map();
  async function read(url, selector, signal) {
    const target = new URL(url, location.origin);
    if (target.origin !== location.origin) throw new Error('Invalid catalogue URL');
    const response = await fetch(target.href, {cache: 'no-store', signal: signal || AbortSignal.timeout(12000)});
    if (!response.ok) throw new Error(window.MayLondonI18n.t('search_error'));
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const value = JSON.parse(html.querySelector(selector)?.textContent || 'null');
    if (!value) throw new Error(window.MayLondonI18n.t('search_error'));
    return value;
  }
  function catalogue(path, {refresh = false} = {}) {
    if (refresh) requests.delete(path);
    if (!requests.has(path)) requests.set(path, (async () => {
      const products = new Map(), seen = new Set();
      let next = new URL(window.MayLondonI18n.route(path), location.origin), currency;
      for (let page = 0; next && page < 20; page++) {
        if (seen.has(next.href)) throw new Error('Repeated catalogue page');
        seen.add(next.href); next.searchParams.set('section_id', 'style-catalog');
        const data = await read(next.href, '[data-style-catalog]');
        if (!Array.isArray(data.products) || (currency && data.currency !== currency)) throw new Error('Invalid catalogue response');
        currency = data.currency;
        for (const product of data.products) if (window.MayLondonStyleEngine.validProduct(product)) products.set(product.handle, product);
        const destination = data.next ? new URL(data.next, location.origin) : null;
        if (destination && (destination.origin !== location.origin || destination.pathname !== next.pathname)) throw new Error('Invalid catalogue page');
        next = destination;
      }
      return {products: [...products.values()], currency, complete: !next};
    })().catch(error => { requests.delete(path); throw error; }));
    return requests.get(path);
  }
  const product = handle => read(window.MayLondonI18n.route('products/' + encodeURIComponent(handle)) + '?section_id=style-product', '[data-style-product]');
  function colours(product) {
    const row = document.createElement('span'); row.className = 'product-card__colours';
    let unknownShown = false;
    for (const item of (Array.isArray(product?.colours) ? product.colours : []).slice(0,30)) {
      if (typeof item.name !== 'string') continue;
      const swatch = document.createElement('span'); swatch.className = 'collection-browser__swatch';
      swatch.title = item.name; swatch.setAttribute('role','img'); swatch.setAttribute('aria-label',item.name);
      if (typeof item.colour === 'string' && CSS.supports('color', item.colour)) swatch.style.setProperty('--filter-swatch',item.colour);
      if (item.image) {
        try { const url = new URL(item.image,location.origin);
          if (url.origin === location.origin || url.protocol === 'https:' && url.hostname === 'cdn.shopify.com') {
            const image = document.createElement('img'); image.src = url.href; image.alt = ''; image.loading = 'lazy'; swatch.append(image);
          }
        } catch (_) { /* Unknown swatches retain the labelled pattern. */ }
      }
      if (!swatch.style.getPropertyValue('--filter-swatch') && !swatch.querySelector('img')) {
        if (unknownShown) continue;
        unknownShown = true;
      }
      row.append(swatch);
    }
    return row;
  }
  window.MayLondonStyleCatalog = {catalogue, product, colours};
})();
